import Vue from 'vue';
import { isFunction } from 'lodash';
import RecorderPreviewDialog from './RecorderPreviewDialog.vue';
const RecorderPreviewDialogConstructor = Vue.extend(RecorderPreviewDialog);

let recorderPreviewDialogInstance = null;


export function openRecordPreviewDialog(options = {}) {
  if (recorderPreviewDialogInstance?.visible) {
    return;
  }

  const propsData = {
    ...options
  };

  const destroy = () => {
    if (recorderPreviewDialogInstance) {
      recorderPreviewDialogInstance.$el.remove();
      recorderPreviewDialogInstance = null;
    }
  };

  propsData.onClose = (props) => {
    destroy();
    if (isFunction(options?.onClose)) {
      options.onClose(props);
    }
  };

  recorderPreviewDialogInstance = new RecorderPreviewDialogConstructor({
    propsData
  });

  document.body.appendChild(recorderPreviewDialogInstance.$mount().$el);
  recorderPreviewDialogInstance.visible = true;
}
